/* eslint-disable max-len */
import superagent from 'superagent';
import QueryString from 'query-string';

const API_PORTAL = process.env.REACT_APP_API_PORTAL;

export default class Clients {
  static get(query) {
    return superagent.get(`${API_PORTAL}/users?${QueryString.stringify(query)}`);
  }

  static getByRut(rut) {
    return superagent.get(`${API_PORTAL}/users/trinidad?rut=${rut}`);
  }

  static getClientPortal(rut) {
    return superagent.get(`${API_PORTAL}/users/get?dni=${rut}`);
  }

  static getClientExists(rut) {
    return superagent.get(`${API_PORTAL}/users/exists`, rut);
  }

  static createClient(data) {
    return superagent.post(`${API_PORTAL}/users`, data);
  }

  static updateClientPassword(dni, email, name) {
    return superagent.post(`${API_PORTAL}/changepassword/?dni=${dni}&email=${email}&name=${name}`);
  }

  // static changePassword(dni, email) {
  //   return superagent.post(`${API_PORTAL}/changepassword/?dni=${dni}&email=${email}`);
  // }
}
